import React, { useCallback, useContext, useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { LocalAdminDTO } from '../../dto/LocalDTO'
import { Close } from '@mui/icons-material'
import { updateScoringManual } from './services/admin.local.services'
import { TenantsContext } from '../../context/tenants.context'
import SnackBarUtils from '../../utils/SnackBarUtils'
import { Info } from '../../pages/AdminLocalPage'

const MAX_SCORING = 5

const Scoring: React.FC<any> = ({
  premise,
  updateLocal
}: {
  premise: LocalAdminDTO
  updateLocal: (codLocal: any) => Promise<void>
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [manual, setManual] = useState<string>(null)
  const [openDetalle, setOpenDetalle] = useState<boolean>(false)
  const { tenant } = useContext(TenantsContext)

  const handleModificar = useCallback(async () => {
    if (!premise?.codLocal) return
    try {
      await updateScoringManual(tenant, premise?.codLocal, Number(manual))
      SnackBarUtils.success('Scoring manual actualizado')
      updateLocal(premise?.codLocal)
    } catch (e) {
      SnackBarUtils.error('Error al actualizar el scoring manual')
      console.log(e)
    } finally {
      handleClose()
    }
  }, [manual, premise])

  const handleOpen = () => {
    setOpenDetalle(true)
    setManual(premise?.scoringManual ? premise?.scoringManual : null)
  }

  const handleClose = () => {
    setOpenDetalle(false)
    setManual(null)
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '8px' : '30px',
          alignItems: isMobile ? 'flex-start' : 'center',
          marginBottom: '18px'
        }}
      >
        <Info>Scoring calculado: {premise?.scoringCalculado}</Info>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
          {Number(premise?.scoringManual) > 0 && <Info>Scoring manual: {premise?.scoringManual}</Info>}
          {isMobile && (
            <button className="btn btn-success" onClick={handleOpen}>
              Ver detalle
            </button>
          )}
        </Box>

        {!isMobile && (
          <Box sx={{ mt: { xs: 1, sm: 0 } }}>
            <button className="btn btn-success" onClick={handleOpen}>
              Ver detalle
            </button>
          </Box>
        )}
      </Box>

      <Dialog
        open={openDetalle}
        onClose={handleClose}
        PaperProps={{
          sx: {
            display: 'flex',
            width: isMobile ? '90%' : { xs: '90vw', sm: 550 },
            maxWidth: isMobile ? '90%' : '90vw',
            marginLeft: '-20px'
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          Detalle Scoring
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
            <Typography>Scoring calculado: {premise?.scoringCalculado}</Typography>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography>Scoring manual (1-{MAX_SCORING}):</Typography>
              <TextField
                value={manual ?? ''}
                sx={{ width: '30%' }}
                type="text"
                onChange={(e) => {
                  const v = e.target.value.replace(',', '.')

                  if (v === '' || /^\d*\.?\d{0,1}$/.test(v)) {
                    const numericValue = parseFloat(v)
                    if (!isNaN(numericValue) && numericValue > 5.0) {
                      setManual('5.0')
                    } else if (!isNaN(numericValue) && numericValue < 1.0) {
                      setManual('1.0')
                    } else {
                      setManual(v)
                    }
                  }
                }}
                variant="outlined"
                size="small"
                inputProps={{
                  inputMode: 'decimal'
                }}
              />

              <Button variant="contained" color="success" onClick={handleModificar}>
                Modificar
              </Button>
            </Box>
            {/* Detalle */}
            {premise?.scoringDetalle && (
              <Box component="ul" sx={{ pl: 2, mb: 0 }}>
                {premise.scoringDetalle
                  .split('|')
                  .map((item, index) => item.trim())
                  .filter(Boolean)
                  .map((item, index) => (
                    <li key={index}>
                      <Typography sx={{ mt: 0.5 }}>{item}</Typography>
                    </li>
                  ))}
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default Scoring
